import "core-js/modules/es.array.push.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.find.js";
import "core-js/modules/esnext.iterator.for-each.js";
import { transformStr3, handleHttp, getformListItemsdata, getformListItemsdatas, insertStr, locationHandle, isWx, locationHandlev2 } from "@/utils/utils";
import Pagination from "@/view/map/customv2/pagination";
import Swiper from "swiper";
import "swiper/css/swiper.css";
import VueAudio from "vue-audio";
// import 'vue-audio-player/dist/vueaudioplayer.css'

import Viewer from "viewerjs";
import "viewerjs/dist/viewer.css";
export default {
  name: "comp1PopUpHubei",
  data() {
    return {
      fid: this.$route.query.fid,
      popLeftArr: [{
        name: "简介",
        id: 0
      }, {
        name: "视频",
        id: 2
      }, {
        name: "学生优秀作品",
        id: 4
      }, {
        name: "思政元素案例",
        id: 5
      }],
      popLeftIndex: 0,
      linkcontainerflag: false,
      iframeurl: "",
      infoList: [],
      videoitem: "",
      videoitemflag: false,
      daohangflag: true,
      viewer: null,
      audiodescflag: false,
      audiodesc: null,
      timer: null,
      structList: [],
      structLabel: {},
      structImgdefaultValues: {},
      showGood: false,
      currentPage: 1,
      // 初始当前页，可根据实际情况设置
      studentWorks: [],
      goodCases: [],
      currentItem: null,
      studentWorksTotal: 0,
      goodCasesTotal: 0
    };
  },
  components: {
    VueAudio,
    Pagination
  },
  watch: {
    "$attrs.popshowflag"(val) {
      if (val) {
        // this.getStudentWorks(this.$attrs.detail.place_name)
        // this.getGoodCases(this.$attrs.detail.place_name)
        console.log(this.$attrs.detail.place_name);
        this.getStudentWorks(this.$attrs.detail.place_name);
        this.getGoodCases(this.$attrs.detail.place_name);
      }
    },
    "$attrs.detail"(val) {
      if (val && Object.keys(val).length > 0) {
        if (this.structList.length === 0) {
          this.pointStruct();
        } else {
          this.setLeftTitle();
        }
      }
    },
    "$attrs.detail.banner"(val) {
      if (val) {
        this.$nextTick(() => {
          this.swiperEl = new Swiper(this.$refs.swipercontainer, {
            initialSlide: 0,
            slidesPerView: this.$attrs.isMobile ? 1 : 2.3,
            autoplay: true,
            speed: 500,
            spaceBetween: this.$attrs.isMobile ? 0 : 10,
            observeSlideChildren: true,
            observeParents: true,
            observer: true
          });
        });
        this.initViewer();
      }
    }
  },
  created() {
    isWx().then(type => {
      this.daohangflag = type === "mini-wx" ? false : true;
    });
  },
  mounted() {
    // this.getStudentWorks(this.$attrs.detail.place_name);
    // this.getGoodCases(this.$attrs.detail.place_name)
  },
  methods: {
    getStudentWorks(location = "", page = 1) {
      let forms = {
        deptId: this.$route.query.fid,
        formId: "xsyxzp",
        page: page,
        limit: 8,
        t: "ea0071355007a143190fbaf5b26554fbaa5084d3028db91d73d6a5f2391a6610"
      };
      let searchStr = {
        model: 0,
        filters: [{
          model: 0,
          filters: [{
            alias: "yxzp_location",
            compt: "selectbox",
            express: "===",
            val: [location]
          }]
        }]
      };
      if (location) {
        forms.searchStr = encodeURI(JSON.stringify(searchStr));
      }
      this.$api.singleadvanceSearchv2(forms).then(res => {
        console.log("singleadvanceSearch", res);
        this.studentWorks = res.dataList;
        this.studentWorksTotal = res.totalPage;
        // this.studentWorks=[...res.dataList,...res.dataList,...res.dataList,...res.dataList]
      });
    },
    getGoodCases(location = "", page = 1) {
      let forms = {
        deptId: this.$route.query.fid,
        formId: "szysal",
        page: page,
        limit: 8,
        t: "ee27e1aa35c220778f923820b83841e7aa5084d3028db91d73d6a5f2391a6610"
      };
      let searchStr = {
        model: 0,
        filters: [{
          model: 0,
          filters: [{
            alias: "ysal_place",
            compt: "selectbox",
            express: "===",
            val: [location]
          }]
        }]
      };
      if (location) {
        forms.searchStr = encodeURI(JSON.stringify(searchStr));
      }
      this.$api.singleadvanceSearchv2(forms).then(res => {
        console.log("getGoodCases", res);
        this.goodCases = res.dataList;
        this.goodCasesTotal = res.totalPage;
      });
    },
    toDetail(item) {
      this.showGood = true;
      this.currentItem = item;
      if (item.yxzp_content && item.yxzp_content.groupValues[0].values[0][0].val) {
        let res = this.replaceIframeSrc(item.yxzp_content.groupValues[0].values[0][0].val);
        this.currentItem.yxzp_content.groupValues[0].values[0][0].val = res;
      }
      if (item.ysal_content && item.ysal_content.groupValues[0].values[0][0].val) {
        let res = this.replaceIframeSrc(item.ysal_content.groupValues[0].values[0][0].val, {
          removeLast: true
        });
        res;
        this.currentItem.ysal_content.groupValues[0].values[0][0].val = res;
        // let timer=setInterval(() => {
        //   if(document.querySelectorAll('.homeworkcontent .editor-iframe')){
        //     console.log('iframe',document.querySelectorAll('.homeworkcontent .editor-iframe'))
        //     clearInterval(timer)
        //   }
        // }, 1000);
        console.log("currentItem", res);
      }
    },
    //     replaceIframeSrc(html, options = {}) {
    //   console.log('html', html);

    //   // 设置默认选项
    //   const defaultOptions = {
    //     targetSrc: "insertVideo.html",
    //     replaceSrc: "https://noteyd.chaoxing.com/attachment/insertVideo.html",
    //     parentClass: "editor-iframe" // 新增默认父元素类名
    //   };
    //   const opts = { ...defaultOptions, ...options };

    //   // 边界条件处理
    //   if (!html || typeof html !== "string") {
    //     console.warn("传入的 HTML 文本无效");
    //     return html;
    //   }

    //   try {
    //     // 创建临时 DOM 元素用于解析 HTML
    //     const tempDiv = document.createElement("div");
    //     tempDiv.innerHTML = html;

    //     // 查找所有包含指定类名的父元素
    //     const parentElements = tempDiv.querySelectorAll(`.${opts.parentClass}`);

    //     // 用于存储替换数量的计数器
    //     let replacedCount = 0;

    //     // 遍历每个父元素，处理其内部的 iframe
    //     parentElements.forEach(parent => {
    //       const iframes = parent.querySelectorAll("iframe");

    //       iframes.forEach(iframe => {
    //         // 检查 src 属性是否包含目标链接
    //         if (iframe.src && iframe.src.endsWith(opts.targetSrc)) {
    //           // 替换为新的链接
    //           iframe.src = opts.replaceSrc;
    //           replacedCount++;
    //           console.log(`已替换 iframe 链接: ${iframe.src}`);
    //         }
    //       });
    //     });

    //     console.log(`共替换了 ${replacedCount} 个 iframe 链接`);

    //     // 返回处理后的 HTML 文本
    //     return tempDiv.innerHTML;
    //   } catch (error) {
    //     console.error("处理 iframe 链接时出错:", error);
    //     return html;
    //   }
    // }  ,
    // replaceIframeSrc(html, options = {}) {
    //   console.log("html", html);

    //   // 设置默认选项
    //   const defaultOptions = {
    //     targetSrc: "insertVideo.html",
    //     replaceSrc: "https://noteyd.chaoxing.com/attachment/insertVideo.html",
    //     parentClass: "editor-iframe",
    //     removeLast: false, // 新增选项：是否移除最后一个 editor-iframe
    //   };
    //   const opts = { ...defaultOptions, ...options };

    //   // 边界条件处理
    //   if (!html || typeof html !== "string") {
    //     console.warn("传入的 HTML 文本无效");
    //     return html;
    //   }

    //   try {
    //     // 创建临时 DOM 元素用于解析 HTML
    //     const tempDiv = document.createElement("div");
    //     tempDiv.innerHTML = html;

    //     // 用于存储替换数量、样式修改数量和移除数量的计数器
    //     let replacedCount = 0;
    //     let styledCount = 0;
    //     let removedCount = 0;

    //     // 移除最后一个 editor-iframe（如果启用该选项）
    //     if (opts.removeLast) {
    //       const editorIframes = Array.from(
    //         tempDiv.querySelectorAll(`.${opts.parentClass}`)
    //       );
    //       if (editorIframes.length > 0) {
    //         const lastEditorIframe = editorIframes[editorIframes.length - 1];
    //         lastEditorIframe.parentNode.removeChild(lastEditorIframe);
    //         removedCount++;
    //         console.log(`已移除最后一个 ${opts.parentClass} 元素`);
    //       }
    //     }

    //     // 查找所有包含指定类名的父元素
    //     const parentElements = tempDiv.querySelectorAll(`.${opts.parentClass}`);

    //     // 遍历每个父元素，处理其内部的 iframe
    //     parentElements.forEach((parent) => {
    //       const iframes = Array.from(parent.querySelectorAll("iframe"));

    //       iframes.forEach((iframe) => {
    //         // 检查内容是否包含错误页面文本
    //         if (
    //           iframe.contentDocument &&
    //           iframe.contentDocument.body &&
    //           iframe.contentDocument.body.innerHTML.includes("Whitelabel Error Page")
    //         ) {
    //           // 移除包含错误页面的 iframe
    //           iframe.parentNode.removeChild(iframe);
    //           removedCount++;
    //           console.log(`已移除包含错误页面的 iframe`);
    //           return; // 跳过后续处理
    //         }

    //         // 检查 src 属性是否包含目标链接
    //         if (iframe.src && iframe.src.endsWith(opts.targetSrc)) {
    //           // 替换为新的链接
    //           iframe.src = opts.replaceSrc;
    //           replacedCount++;
    //           console.log(`已替换 iframe 链接: ${iframe.src}`);
    //         }

    //         // 为 iframe 追加样式
    //         const originalStyle = iframe.getAttribute("style") || "";
    //         const newStyle = "width:95%;height:420px;";

    //         // 合并样式并避免重复添加
    //         if (!originalStyle.includes(newStyle)) {
    //           iframe.setAttribute("style", `${newStyle} ${originalStyle}`);
    //         }
    //       });
    //     });

    //     console.log(`共替换了 ${replacedCount} 个 iframe 链接`);
    //     console.log(`共为 ${styledCount} 个 iframe 添加了样式`);
    //     console.log(`共移除了 ${removedCount} 个元素`);

    //     // 返回处理后的 HTML 文本
    //     return tempDiv.innerHTML;
    //   } catch (error) {
    //     console.error("处理 iframe 时出错:", error);
    //     return html;
    //   }
    // },

    replaceIframeSrc(html, options = {}) {
      console.log("html", html);

      // 设置默认选项
      const defaultOptions = {
        targetSrc: "insertVideo.html",
        replaceSrc: "https://noteyd.chaoxing.com/attachment/insertVideo.html",
        parentClass: "editor-iframe",
        removeLast: false // 新增选项：是否移除最后一个 editor-iframe
      };
      const opts = {
        ...defaultOptions,
        ...options
      };

      // 边界条件处理
      if (!html || typeof html !== "string") {
        console.warn("传入的 HTML 文本无效");
        return html;
      }
      try {
        // 创建临时 DOM 元素用于解析 HTML
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = html;

        // 用于存储替换数量、样式修改数量和移除数量的计数器
        let replacedCount = 0;
        let styledCount = 0;
        let removedCount = 0;

        // 查找所有包含指定类名的父元素
        const parentElements = tempDiv.querySelectorAll(`.${opts.parentClass}`);

        // 遍历每个父元素，处理其内部的 iframe
        parentElements.forEach(parent => {
          const iframes = Array.from(parent.querySelectorAll("iframe"));
          iframes.forEach(iframe => {
            // 检查内容是否包含错误页面文本

            // 检查 src 属性是否包含目标链接
            if (iframe.src && iframe.src.endsWith(opts.targetSrc) || iframe.src && iframe.src.endsWith("insertCloud.html")) {
              // 特殊处理：如果目标是 insertCloud.html，则删除该 iframe
              if (iframe.src.endsWith("insertCloud.html")) {
                // iframe.parentNode.removeChild(iframe);
                iframe.src = "https://noteyd.chaoxing.com/attachment/insertCloud.html";
                replacedCount++;
              }
              if (iframe.src.endsWith(opts.targetSrc)) {
                // iframe.parentNode.removeChild(iframe);
                iframe.src = opts.replaceSrc;
                replacedCount++;
                // 为 iframe 追加样式
                const originalStyle = iframe.getAttribute("style") || "";
                const newStyle = "width:95%;height:410px;";
                // 合并样式并避免重复添加
                if (!originalStyle.includes(newStyle)) {
                  iframe.setAttribute("style", `${newStyle} ${originalStyle}`);
                  styledCount++; // 增加样式修改计数器
                }
              }
              // 替换为新的链接
              replacedCount++;
              // console.log(`已替换 iframe 链接: ${iframe.src}`);
            }
          });
        });

        // console.log(`共替换了 ${replacedCount} 个 iframe 链接`);
        // console.log(`共为 ${styledCount} 个 iframe 添加了样式`);
        // console.log(`共移除了 ${removedCount} 个元素`);

        // 返回处理后的 HTML 文本
        return tempDiv.innerHTML;
      } catch (error) {
        console.error("处理 iframe 时出错:", error);
        return html;
      }
    },
    homeback() {
      this.showGood = false;
    },
    handlePageChange(newPage) {
      this.currentPage = newPage;
      console.log(this.popLeftIndex);
      console.log("newPage", newPage);
      if (this.popLeftIndex == 4) {
        this.getStudentWorks(this.$attrs.detail.place_name, newPage);
        // this.getGoodCases(this.$attrs.detail.place_name,newPage)
      }
      if (this.popLeftIndex == 5) {
        // this.getStudentWorks(this.$attrs.detail.place_name,newPage)
        this.getGoodCases(this.$attrs.detail.place_name, newPage);
      }
      // 这里可调用接口，根据 newPage 获取对应页的数据，比如：
      // this.fetchData(newPage);
    },
    // 统一换地址
    sethandleHttp(url) {
      return handleHttp(url);
    },
    // 关闭事件
    closePop() {
      this.showGood = false;
      this.$emit("closeHandle");
      this.popshowflag = false;
      this.popLeftIndex = 0;
      if (this.audiodescflag) {
        this.$refs.audiodesc.pause();
        this.audiodescflag = false;
      }
      this.closevideoItem();
    },
    closevideoItem() {
      this.videoitemflag = false;
      this.videoitem = "";
    },
    // 弹窗左边点击事件
    popLeftHandle(id) {
      this.popLeftIndex = id;
    },
    // 返回事件
    goback() {
      this.linkcontainerflag = false;
      this.iframeurl = "";
    },
    goLocation(url) {
      locationHandlev2.call(this, this.$attrs.detail, url);
    },
    // 跳转
    goLink(url) {
      // 若选择打开新窗口处理
      if (this.$attrs.detail.linkTarget !== undefined && this.$attrs.detail.linkTarget === "是") {
        window.open(url);
      } else {
        this.linkcontainerflag = true;
        this.iframeurl = url;
      }
    },
    // 视频切换
    videoItemHandle(item) {
      this.videoitemflag = true;
      this.videoitem = this.popLeftIndex === 2 ? item : item.itemformdata;
    },
    initViewer() {
      this.$nextTick(() => {
        if (this.viewer) {
          this.viewer.destroy();
          this.viewer = null;
          return;
        }
        let that = this;
        this.viewer = new Viewer(document.querySelector(".swiper-wrapper"), {
          navbar: true,
          // 显示导航栏
          toolbar: true,
          // 显示工具栏
          title: false,
          viewed() {
            console.log(`this.$attrs.imgrotate`, that.$attrs.imgrotate);
            if (that.$attrs.imgrotate !== undefined && that.$attrs.imgrotate) that.viewer.rotateTo(90);
            document.querySelector(".viewer-container").classList.add(`fid${that.$route.query.fid}`);
          }
        });
      });
    },
    getAddress(val) {
      let data = val[0];
      let addressArr = ["country", "province", "city", "district", "street"];
      let str = "";
      addressArr.forEach(elem => {
        if (data[elem] && data[elem] !== undefined && data[elem] !== "") str += data[elem];
      });
      if (str === "" && data.address !== undefined) str = data.address;
      return str;
    },
    playaudiodesc() {
      this.audiodescflag = !this.audiodescflag;
      if (this.audiodescflag) {
        this.$refs.audiodesc.pause();
      } else {
        this.$refs.audiodesc.play().catch(error => {
          console.error("Play request was interrupted:", error);
        });
      }
    },
    /**
     * 获取地点管理表表单结构
     */
    pointStruct() {
      let params = {
        deptId: this.$route.query.fid,
        formId: 165054
      };
      this.$api.formStruct(params).then(res => {
        this.structList = JSON.parse(JSON.stringify(res));
        this.structList.forEach(elem => {
          if (elem.compt === "imagebox" && elem.field.values.length > 0) this.structImgdefaultValues[elem.alias] = elem.field.values[0].fileUrl;
          this.structLabel[elem.alias] = elem.label;
        });
        this.setLeftTitle();
        console.log(`this.structLabel`, this.structLabel);
        console.log(`this.structImgdefaultValues`, this.structImgdefaultValues);
      });
    },
    setLeftTitle() {
      let audioList = this.$attrs.detail.audio;
      if (audioList && audioList.length > 0) {
        let isHasaudio = this.popLeftArr.find(item => {
          return item.id === 3;
        });
        if (!isHasaudio) this.popLeftArr.push({
          name: this.structLabel.audio,
          id: 3
        });
      }
      let videoList = this.$attrs.detail.video;
      if (videoList && videoList.length > 0) {
        let isHasvideo = this.popLeftArr.find(item => {
          return item.id === 2;
        });
        if (!isHasvideo) this.popLeftArr.push({
          name: this.structLabel.video,
          id: 2
        });
      }
    }
  }
};